import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../../src/utils/is-valid-json-string';
import Guid from '../utils/guid';
import { CHAT_MSG_TYPE, VASCO_FLOW, VASCO_MODAL_TYPES } from '../../src/constants';

const CHAT_PATH = 'roster.data.chat';

export default () => muster()
  .path('chat.showWelcomeScreen', variable(true))
  .path('chat.expand', variable(false))
  .path('chat.showChat', variable(false))

  .path('chat.fetchUserList', {
    call: async ({ req }, { get, set }) => {
      const guidStr = Guid();
      const [result] = await getValues(get(`${CHAT_PATH}.getFetchUserList["${guidStr}"]`));

      isValidJsonString(result).then(async (userList) => {
        if (userList.retCode.toString() === 'SUCCESS' || userList.retCode.toString() === '0') {
          await set('chat.userList', userList.users);
          await set('chat.fromUserDetails', userList.fromUser);
          await set('chat.loadingUserList', false);
        }
      }).catch(async (error) => {
        console("unable to fetch userList for chat-home" + error);
        await set('chat.loadingUserList', false);
      })
    }
  })

  .path('chat.fetchChatHistory', {
    call: async ({ req }, { get, set }) => {


      const guidStr = Guid();
      const { toUserId, pageNumber } = req.args[0];

      const inputs = `${toUserId}#@#${pageNumber}`;

      const [result] = await getValues(get(`${CHAT_PATH}.getFetchChatHistory["${inputs}"]["${guidStr}"]`));
      isValidJsonString(result).then(async (history) => {
        if (history.retCode.toString() === 'SUCCESS' || history.retCode.toString() === '0') {
          await set('chat.chatHistory', history.messages);
        }
      }).catch(async (error) => {
        console("unable to fetch chathistory for chat-home" + error);
      })
    }
  })

  .path('chat.saveOnlineServiceTerms', {
    call: async ({ req }, { set, get, call }) => {
      let { seenTerms, seenPrivacy, termsUrl, privacyUrl, tcVersion, paVersion, termsChatUrl, seenChatTerms, tcChatVersion } = req.args[0];
      let channel = 'web';
      const [messages] = await getValues(get('i18n.messages'));
      if (termsChatUrl) termsChatUrl = termsChatUrl.replace('.', '<dot>');
      let [result] = await getValues(get(`roster.data.terms.saveTermsConditions.encrypted-${seenTerms}.encrypted-${seenPrivacy}.encrypted-${channel}.encrypted-${termsUrl}.encrypted-${privacyUrl}.encrypted-${tcVersion}.encrypted-${paVersion}.encrypted-${termsChatUrl}.encrypted-${seenChatTerms}.encrypted-${tcChatVersion === null ? '' : tcChatVersion}`));
      isValidJsonString(result).then(async (saveTermsResponse) => {
        if (saveTermsResponse && saveTermsResponse.status == "SUCCESS") {
          await set('terms.showTermsConditionsChat', false);
        } else {
          await set('chat.saveOnlineServiceTermsErrorMessage', messages['app.chat.error.tryagain']);
        }
      }).catch(async () => {
        await set('chat.saveOnlineServiceTermsErrorMessage', messages['app.chat.error.tryagain']);
      });
    }
  })

  .path('chat.wsUrl', variable())
  .path('chat.webSocket', variable(null))
  .path('chat.userList', variable([]))
  .path('chat.chatHistory', variable([]))
  .path('chat.toUserActive', variable([]))
  .path('chat.isNewMsg', variable(false))
  .path('chat.fromUserDetails', variable())
  .path('terms.showTermsConditionsChat', variable(false))
  .path('terms.tcChatPdfLink', variable(""))
  .path('terms.tcChatPdfLinkErrorDescption', variable(""))
  .path('terms.tcChatVersion', variable(""))
  .path('terms.newUserChatTc', variable(false))
  .path('chat.chatIconClick', variable(false))
  .path('chat.loadingUserList', variable(true))
  .path('chat.closeWS', variable(false))
  .path('chat.newMessage', variable([]))
  .path('chat.randomString', variable(''))
  .path('chat.isDownloading', variable(false))
  .path('chat.chatError', variable(''))
  .path('chat.recvNewMessage',variable(false))
  .path('chat.isChatSelected', variable(false))
  .path('chat.saveOnlineServiceTermsErrorMessage', variable(""))
  .path('chat.handleNavigation', {
    call: async ({ req }, { get, set, call }) => {

      let [rsaAuthvalue] = await getValues(get('rsa.rsaAuthorised'));
      let [vascoLoginType] = await getValues(get('auth.vascoFlow'));
      let [vascoAuthvalue] = await getValues(get('vascoauthentication.vascoAuthorised'));
      const [showTermsConditionsChat] = await getValues(get('terms.showTermsConditionsChat'));
      const [isChatClicked] = await getValues(get('chat.isChatSelected'));
      if (!isChatClicked)
        await set('chat.isChatSelected', true);

      if (vascoLoginType == VASCO_FLOW.browser) {
        if (vascoAuthvalue === undefined || vascoAuthvalue === false) {
          set('vascoauthentication.vascoVisible', true);
          set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.pin2fa);
        }
        else {
          if (showTermsConditionsChat) {
            await set('chat.showWelcomeScreen', true)
          }
          else {
            await set('chat.showChat', true);
          }
        }
      }
      else {
        if (rsaAuthvalue === undefined || rsaAuthvalue === false) {
          set('rsa.rsaVisible', true)
        } else {
            set('rsa.rsaVisible', false);
          
              if (showTermsConditionsChat) {
                await set('chat.showWelcomeScreen', true)
              }
              else {
                await set('chat.showChat', true);
              }
        }
      }      
    }
  })
  .path('chat.connectWebSocket', {
    call: async ({ req }, { get, set, call }) => {
      const isWSClosed = await getValues(get('chat.closeWS'));
      const [webSocketURL] = await getValues(get('app.config.chat.url'));

      let [webSocket] = await getValues(get('chat.webSocket'));
      try {
        if (!webSocket) {
          const [userId] = await getValues(get('auth.userId'));
          const [authHeader] = await getValues(get('auth.authHeader'));
          webSocket = new WebSocket(webSocketURL + '?userId=' + userId, authHeader);
        }
        webSocket.onopen = () => handleWebSocketOpen();
        webSocket.onmessage = (messageEvent) => handleIncomingData(messageEvent);
        webSocket.onerror = (event) => handleError(event);
        webSocket.onclose = () => handleOnClose();
        await set('chat.webSocket', webSocket);
      } catch (ex) {
        console.error("Error creating web-socket" + ex);
      }

      function handleWebSocketOpen() {
        console.log('handleWebSocketOpen');
      }

      async function handleIncomingData(messageEvent) {
        const guidString = Guid();
        const incomingMessage = JSON.parse(messageEvent.data);
        if (incomingMessage.msgType === CHAT_MSG_TYPE.CHAT_MSG) {
          const [chatHistory] = await getValues(get('chat.chatHistory'));
          const [toUserActive] = await getValues(get('chat.toUserActive'));

          await set('chat.recvNewMessage', true);
          set('chat.randomString', guidString);
          if( toUserActive && incomingMessage.fromUserId === toUserActive.userId){
            chatHistory.push(incomingMessage);
            await set('chat.chatHistory', chatHistory);
          }      
        }
      }

      function handleError() {
        console.log('handleError: ');
      }

      async function handleOnClose() {
        if (!isWSClosed || webSocket.readyState === 3 || webSocket.readyState) {
          try {
            const [userId] = await getValues(get('auth.userId'));
            const [authHeader] = await getValues(get('auth.authHeader'));
            // webSocket = new WebSocket(localWS + '?userId=' + userId + authHeader);
            webSocket = new WebSocket(webSocketURL + '?userId=' + userId, authHeader);

            webSocket.onopen = () => handleWebSocketOpen();
            webSocket.onmessage = (messageEvent) => handleIncomingData(messageEvent);
            webSocket.onerror = (event) => handleError(event);
            webSocket.onclose = () => handleOnClose();
            await set('chat.webSocket', webSocket);
          } catch (ex) {
            console.error("Error creating web-socket" + ex);
          }
        }
      }
    }
  })



  ;
